<template>
  <div class="Fb">     
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.56 39.56">
        <g>
            <g>
                <rect class="cls-1" x=".75" y=".75" width="38.06" height="38.06" rx="19.03" ry="19.03"/>
                <path class="cls-2" d="M16.88,31.28h4.63v-11.6h3.23l.34-3.88h-3.58v-2.21c0-.92,.18-1.28,1.07-1.28h2.51v-4.03h-3.21c-3.45,0-5,1.52-5,4.42v3.1h-2.41v3.93h2.41v11.55Z"/>
            </g>
        </g>
    </svg>
  </div>
</template>

<script>

import gsap from "gsap"
export default {
  name: 'Fb',
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Fb
    position relative
    display flex 
    align-items center
    justify-content center
    
    & svg
        width 100%
        .cls-1
            fill none
            stroke #222221
            stroke-miterlimit 10
            stroke-width 1.5px 
        .cls-2
            fill #222221
</style>


